import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CheckPermission, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser } from "../../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../../context";
import { DeleteJobsApi, JobsApi, JobsChangeStatusApi } from "../../../api";
import { Link } from 'react-router-dom'

export const Job = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "عنوان شغل",
            render: (i: any) => (<div className="h-[40px] flex items-center">{i.name && i.name != null && i.name}</div>)
        },
        {
            title: "گروه شغلی",
            render: (i: any) => (<div className="h-[40px] flex items-center">{i.group && i.group != null && i.group?.name}</div>)
        },
        {
            title: "توضیحات ",
            render: (i: any) => (<>{i.description && i.description != null && i.description}</>)
        },
        {
            title: "وضعیت",
            render: (i: any) => (<>
                <CToggle onChange={(e: any) => handelChangeToggle(e, i.name, i.id)} defaultChecked={i.status == 1 ? true : false} />
            </>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-around ">
                    {CheckPermission(46) &&
                        <Link to={`/p/settings/job/${i.id}`}>
                            <img src="/assetes/svg/edit.svg" className="w-[20px] cursor-pointer" />
                        </Link>
                    }
                    {CheckPermission(47) &&
                        <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] cursor-pointer" />
                    }
                </div>)
        },

    ]

    const handelChangeToggle = async (e: any, name: string, id: number) => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await JobsChangeStatusApi(e.target.checked, name, id)
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.success) {
            toast("تغییر وضعیت صورت گرفت", { type: "success" })
            // getData()
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }

    }

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteRoll = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteJobsApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData()
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }



    const getData = async () => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await JobsApi()
            setTableData(res.data)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "مشاغل | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 1, })
        getData()

    }, [])

    return (
        <div className=" w-full flex flex-col">

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <h1 className="sm:text-2xl text-lg font-bold mb-[30px] md:mb-0">مدیریت مشاغل</h1>

                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                    {CheckPermission(45) ?
                        <button className=" w-full md:w-[120px] h-[30px] md:h-[40px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                            <Link to='/p/settings/job/add' className=" w-full h-full flex justify-center items-center">
                                + اضافه کردن شغل
                            </Link>
                        </button>
                        :
                        <div />
                    }
                </div>
            </div>

            {CheckPermission(44) &&
                <div className=" w-full mt-[20px]">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} />
                        :
                        <CSkeletonTable />
                    }
                </div>
            }

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteRoll} loading={CtxLoad.displayLoadingBtn} />

        </div>
    )
}
